import { Dispatch } from 'redux';
import { fetchTasks } from '../../../../services/discovery/fetchTasks';
import { makeFetchModule } from '../../../_utils';
import { storeSourceSets } from '../../entities';

const callbacks = {
    onSuccess: (dispatch: Dispatch, { entities }: { entities: object }) => {
        dispatch(storeSourceSets(entities));
    },
};
const { reducer, fetchData, reset } = makeFetchModule(
    'app/discovery/tasksFetching',
    fetchTasks,
    callbacks
);

export default reducer;
export { fetchData, reset };
